module.exports = __webpack_public_path__ + "static/media/Icons_connect.df5c4897.svg";